import { CircleAlert, CircleCheck, Clock3 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { FunnelStatItem } from './FunnelStatItem'
import type { PackedItemsFunnelStats } from './packedItemsOverviewStats'
import { formatStatFraction } from './packagingSupplierStats'

type PackedItemsFunnelStatsRowProps = {
  stats: PackedItemsFunnelStats
}

export function PackedItemsFunnelStatsRow({
  stats,
}: PackedItemsFunnelStatsRowProps) {
  const { t } = useTranslation('packagingSuppliers')

  return (
    <div className='grid shrink-0 gap-2 sm:grid-cols-2 lg:grid-cols-3'>
      <FunnelStatItem
        label={t('stats.packedItemsUnaddressed')}
        tooltip={t('stats.packedItemsUnaddressedTooltip')}
        icon={
          <CircleAlert className='size-4 text-destructive' aria-hidden />
        }
        percent={stats.unaddressedPercent}
        description={formatStatFraction(stats.unaddressed, stats.total)}
      />
      <FunnelStatItem
        label={t('stats.packedItemsInProgress')}
        tooltip={t('stats.packedItemsInProgressTooltip')}
        icon={
          <Clock3
            className='size-4 text-amber-600 dark:text-amber-500'
            aria-hidden
          />
        }
        percent={stats.inProgressPercent}
        description={formatStatFraction(stats.inProgress, stats.total)}
      />
      <FunnelStatItem
        label={t('stats.packedItemsCompleted')}
        tooltip={t('stats.packedItemsCompletedTooltip')}
        icon={
          <CircleCheck
            className='size-4 text-green-600 dark:text-green-500'
            aria-hidden
          />
        }
        percent={stats.completedPercent}
        description={formatStatFraction(stats.completed, stats.total)}
      />
    </div>
  )
}
